import React, { useState } from 'react';
import CustomButton from '../../../components/CustomButton/CustomButton';
import Notification from 'grommet/components/Notification';
import { useMutation } from 'react-query';
import FormCreator from '../../../components/UI/FormCreator/FormCreator';
import { updateObject, checkValidity, returnErrorTextForField, returnErrorFromResponse } from '../../../shared/utility';
import { ALL_CLASS_WITH_CLASS_TYPES } from '../../../constants';
import { returnFAQFields } from './returnsFAQFields';
import { addFAQ, delayFetchFunctions, editFAQ } from '../../../apiFunctions/apiFunctions';
import CustomToast from '../../../components/CustomToast/CustomToast';
import Loading from '../../../components/Loading/Loading';

const AddEditFAQ = ({ selectedGym, selectedFAQ, onClose }) => {
  const KESpecificQueType = ['gym', 'swim', 'tennis', 'massage', 'gym2'];
  const [formIsValid, setFormIsValid] = useState(false);
  const [formValidated, setFormValidated] = useState(false);
  const classTypes = ALL_CLASS_WITH_CLASS_TYPES();
  const updateSelectedFAQ = (selectedFAQObj) => {
    if (selectedFAQObj && KESpecificQueType.includes(selectedFAQObj.questionType)) {
      let classType = classTypes.find((classType) => classType.faqType === selectedFAQObj.questionType);
      selectedFAQObj.questionType = classType.name;
    }
    return selectedFAQObj;
  };
  const [formFields, setFormFields] = useState(
    returnFAQFields(selectedGym.settings, selectedFAQ ? updateSelectedFAQ(selectedFAQ) : null)
  );
  const [toast, setToast] = useState(null);

  const isNewFaq = selectedFAQ === null || selectedFAQ === undefined;

  const mutateFAQ = useMutation(
    (formData) => (isNewFaq ? addFAQ(selectedGym._id, formData) : editFAQ(selectedFAQ._id, formData)),
    {
      onSuccess: () => {
        setToast({
          status: 'ok',
          msg: isNewFaq ? 'Successfully added' : 'Successfully updated',
          show: true
        });
        delayFetchFunctions([['faq']], 1000);
        onClose();
      },
      onError: (err) => {
        setToast({
          status: 'critical',
          msg: returnErrorFromResponse(err),
          show: true
        });
      }
    }
  );

  const KESpecificNames = ['gym bookings 1', 'gym bookings 2', 'swim bookings 1', 'swim bookings 2', 'dining Room'];

  const valueChangedHandler = (newValue, identifier) => {
    const updatedNewFAQ = updateObject(formFields, {
      [identifier]: updateObject(formFields[identifier], {
        value: newValue,
        valid: checkValidity(newValue, formFields[identifier].validation),
        errorText: returnErrorTextForField(formFields[identifier].validation),
        touched: true
      })
    });
    setFormFields(updatedNewFAQ);
    setFormValidated(false);
  };

  const checkFormValidity = () => {
    setFormValidated(true);

    for (let input in formFields) {
      if (!formFields[input].valid) {
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
        return setFormIsValid(false);
      }
    }
    setFormIsValid(true);
    saveFAQ();
  };

  const saveFAQ = () => {
    const formData = {};
    for (let input in formFields) {
      if (input === 'questionType' && KESpecificNames.includes(formFields[input].value)) {
        let classType = classTypes.find((classType) => classType.name === formFields[input].value);
        formData[input] = classType.faqType ?? formFields[input].value;
      } else {
        formData[input] = formFields[input].value;
      }
    }
    mutateFAQ.mutate(formData);
  };

  let formWarning = !formIsValid && formValidated && (
    <Notification message="Form is not filled in correctly" status="warning" className="ss-top-notification" />
  );

  const button = mutateFAQ.isLoading ? (
    <Loading topOffset={'50px'} />
  ) : (
    <CustomButton
      style={{ marginTop: '50px', display: 'block' }}
      label={isNewFaq ? 'Add' : 'Save'}
      secondary={true}
      onClick={checkFormValidity}
    />
  );

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '20px' }}>
        <CustomButton label={'FAQ list'} secondary={true} onClick={onClose} />
      </div>
      <div>
        <CustomToast toast={toast} />
        {formWarning}
        <FormCreator formData={formFields} valueChanged={valueChangedHandler} />
        {button}
      </div>
    </div>
  );
};

export default AddEditFAQ;
